<template>
  <section v-if="loaded && userHasLoaded">

    <div v-if="!meeting_enabled">

      <div class="center-information">      
        <div class="center-information-content">
        <i class="fa-light fa-2x fa-video-slash"></i>  
        <br /><br />
        {{ $t('NO_MEETING_SERVICE', { appHostName: teams.name }) }}  
        </div>
      </div>


    </div>
    <div v-if="meeting_enabled" class="flex" v-show="message_uuid == ''">
      <b-form inline class="mt-2">

        <AddressBook v-if="!checkValidVersion('4.4.0')"
        user_uuid=""
        functionbox_uuid=""
        v-slot:activator="{ onClick }"
      >
        <b-button
          @click="onClick"
          class="no-border"
          v-b-tooltip.hover
          :title="$t('ADDRESSBOOK.TITLE')"
        >
          <i class="fal fa-address-book"></i
        ></b-button>
      </AddressBook>
      <AddressBook_4_4 v-if="checkValidVersion('4.4.0')"
      user_uuid=""
      functionbox_uuid=""
      v-slot:activator="{ onClick }"
    >
      <b-button
        @click="onClick"
        class="no-border"
        v-b-tooltip.hover
        :title="$t('ADDRESSBOOK.TITLE')"
      >
        <i class="fal fa-address-book"></i
      ></b-button>
    </AddressBook_4_4>

        <span><b-button @click="refreshList" class="no-border"><i class="fal fa-sync"></i></b-button></span>
        <AddMeeting_4_4         
          v-if="user.version && checkValidVersion('4.4.0')"
          @Close="CloseAddMeeting"
          :key="addMeeetingKey"
          :functionbox_uuid="functionbox_uuid"
          :user_uuid="user_uuid"
          @Changed="Changed"
          :draftInformation="draftInformation"
        ></AddMeeting_4_4>

       
        <label class="sr-only" for="inline-form-input-search">{{$t('SEARCH')}}</label>
        <b-form-input trim
          id="inline-form-input-search"
          class="i-100 searchText hidden-mobile ml-2"
          v-model="searchText"
          :placeholder="$t('SEARCH')"
          @keydown.enter.prevent
        ></b-form-input>
        <label class="sr-only" for="inline-form-input-limit">{{$t('LIMIT')}}</label>
        <b-form-select id="inline-form-input-limit" name="messages_limit" v-model="limit" class="limit hidden-mobile">
            <b-form-select-option value="10">10</b-form-select-option>
            <b-form-select-option value="25">25</b-form-select-option>
            <b-form-select-option value="45">45</b-form-select-option>
            <b-form-select-option value="100">100</b-form-select-option>
        </b-form-select>
      </b-form>

      
      <div class="hidden-not-mobile w-100 mt-2">
        <b-form inline>
          <label class="sr-only" for="inline-form-input-search">{{$t('SEARCH')}}</label>
          <b-form-input trim
            class="ml-2 i-100 searchText"
            v-model="searchText"
            :placeholder="$t('SEARCH')"
            @keydown.enter.prevent
          ></b-form-input>
          <label class="sr-only" for="inline-form-input-limit">{{$t('LIMIT')}}</label>
          <b-form-select id="inline-form-input-limit" name="meetings_limit"  v-model="limit" class="limit">
            <b-form-select-option value="10">10</b-form-select-option>
            <b-form-select-option value="25">25</b-form-select-option>
            <b-form-select-option value="45">45</b-form-select-option>
            <b-form-select-option value="100">100</b-form-select-option>
          </b-form-select>
        </b-form>
      </div>
      
      <b-nav tabs v-if="checkValidVersion('4.4.0')" class="mt-2">
        <b-nav-item
          :to="{
            name: 'Meetings.Calendar',
            params: { searchText: searchText },
          }"
          exact
          >{{ $t("MEETINGS.CALENDAR") }}</b-nav-item
        >

        <b-nav-item :to="{ name: 'Meetings.Drafts' }" exact>
          {{ $t("MESSAGES.DRAFTS") }}
        </b-nav-item>
      </b-nav>

      <router-view
        :key="addMeeetingKey"
        @viewingMessage="viewingMessage"
        :update_message_uuid="update_message_uuid"
        @changeUpdateMessageUuid="changeUpdateMessageUuid"        
        @draftMeeting="DraftMeeting"
        :searchText.sync="searchText"
        :limit.sync="limit"
      ></router-view>

    </div>
    <div  class="flex" v-if="message_uuid != ''">
      <Message_4_4 
        v-if="checkValidVersion('4.4.0')"
        :message_uuid="message_uuid"
        functionbox_uuid=""
        show-close-btn
        :startMeeting="startMeeting"
        :endMeeting="endMeeting"
        @refreshList="refreshList"
        @closeMessage="closeMessage"></Message_4_4>        
        <Message 
        v-if="!checkValidVersion('4.4.0')"
        :message_uuid="message_uuid"
        functionbox_uuid=""
        show-close-btn
        @refreshList="refreshList"
        @closeMessage="closeMessage"></Message>        
    </div>
  </section>
</template>
<script>
import AddressBook from "@/components/AddressBook/Page";
import AddressBook_4_4 from "@/components_4_4/AddressBook/Page";
import teamsMethods from "@/mixins/teamsMethods";
import Message from "@/components/View/Message.vue";
import Message_4_4 from "@/components_4_4/View/Message.vue";
import AddMeeting_4_4 from "@/components_4_4/Compose/AddMeeting";
export default {  
  props: ["functionbox_uuid", "user_uuid", "email", "view_message_uuid"],
  mixins: [teamsMethods],
  components: {
    Message,
    AddressBook,
    AddMeeting_4_4,
    Message_4_4,
    AddressBook_4_4
  },
  data() {
    return {
      startMeeting: null,
      endMeeting: null,
      draftInformation: null,
      currentView: "WorkWeek",
      message_uuid: "",
      update_message_uuid: "",
      information: null,
      modalShow: false,
      modalShowJitsi: false,
      modalShowJitsiSecure: false,
      searchText: "",
      meeting_enabled: true,
      key: 0,
      limit: 45,
      loaded: false,
      selectedTab: 'calendar',
    };
  },
  methods: {
    Changed() {
      this.draftInformation = null;
      this.refreshList();
    },
    CloseAddMeeting(){
      this.draftInformation = null;
      this.refreshList();
    },
    DraftMeeting(draftInformation) {
      this.draftInformation = draftInformation;      
      this.message_uuid = "";
      this.update_message_uuid = "";
      this.startMeeting = null;
      this.endMeeting = null;
    },
    async checkEnabledMeetings(){
      let self = this;
      if(this.checkValidVersion('4.2.0'))
      {      
        let self = this;
        await this.$http
          .get(this.user.hostname + "/meeting/enabled")
          .then(function(result) {
            console.log(result);
            self.meeting_enabled = result.data;
            self.loaded = true;
        })
        .catch(function() {
          self.meeting_enabled = false;
          self.loaded = true;
        });
      }else{
        self.meeting_enabled = true;
        self.loaded = true;
      }
    },
    sentMeeting() {
      console.log("sentMeeting");
      this.refreshList();
    },
    changedView(view) {
      this.currentView = view;
    },
    changeUpdateMessageUuid(update_message_uuid) {
      this.update_message_uuid = update_message_uuid;
      this.message_uuid = "";
      this.draftInformation = {        
        messageUuid: '',
        location: ''
      };
      this.startMeeting = null;
      this.endMeeting = null;
    },
    refreshList(){
      console.log("refreshList");
      this.key++;
    },
    closeMessage() {
      this.update_message_uuid = this.message_uuid;
      this.message_uuid = "";
      this.draftInformation = null;
      this.startMeeting = null;
      this.endMeeting = null;
    },
    hideModal() {
      this.modalShow = false;
      this.modalShowJitsi = false;
      this.modalShowJitsiSecure = false;
    },
    viewingMessage(item) {
      if(item.MessageUuid == undefined)
      {
        this.update_message_uuid = "";
        this.draftInformation = null;
        this.message_uuid = item;
      }else{        
        this.message_uuid = item.MessageUuid;
        this.draftInformation = null;
        this.update_message_uuid = "";
        if(item.Recurrence != null)
        {
          this.startMeeting = item.StartTime;
          this.endMeeting = item.EndTime;
        }else{
          this.startMeeting = null;
          this.endMeeting = null;
        }
      }
    },
    selectTab(tab) {
      this.selectedTab = tab;
      this.refreshList();
    },
  },
  computed: {
    listMeetingKey() {
      return "listMeeting" + this.key;
    },
    addMeeetingKey() {
      return "addMeeeting" + this.key;
    }
  },
  mounted() {
    this.checkEnabledMeetings();
    console.log("mounted Meeting Page");
  },
};
</script>
<style></style>
